import { createContext, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetPortal } from "../hooks/useGetPortal";

type PublicUserContextType = {
	portalUid?: string;
	stationName?: string;
	language?: string;
	portalLoading: boolean;
	postalCode?: string;
	locality?: string;
	portal?: string;
};

const PublicUserContext = createContext<PublicUserContextType | null>(null);

export const PublicUserProvider = ({
	children,
	setLocale,
}: {
	children: React.ReactNode;
	setLocale: (locale: "en" | "de" | "fr") => void;
}) => {
	const { portal, language } = useParams();

	useEffect(() => {
		if (language) {
			const lang = language.split("-")[0];
			if (["en", "de", "fr"].includes(lang)) {
				setLocale(lang as "en" | "de" | "fr");
			} else {
				setLocale("en");
			}
		} else {
			setLocale("en");
		}
	}, [language]);

	const { data: portalResult, isLoading } = useGetPortal(portal as string);

	const values: PublicUserContextType = {
		portalUid: portalResult?.portalId,
		stationName: portalResult?.stationName,
		language: language,
		portalLoading: isLoading,
		postalCode: portalResult?.postalCode,
		locality: portalResult?.locality,
		portal: portal as string,
	};

  console.log("PublicUserContext values:", values);

	return <PublicUserContext.Provider value={values}>{children}</PublicUserContext.Provider>;
};

export const usePublicUser = () => useContext(PublicUserContext)!;
